import { render, staticRenderFns } from "./AsiCardDetailEntry.vue?vue&type=template&id=07cea800&scoped=true&"
import script from "./AsiCardDetailEntry.vue?vue&type=script&lang=ts&"
export * from "./AsiCardDetailEntry.vue?vue&type=script&lang=ts&"
import style0 from "./AsiCardDetailEntry.vue?vue&type=style&index=0&id=07cea800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cea800",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle})
